import demoMessageFn from './demoMessage';
import SystemData from '../../lib/systemData';
import { stores } from '../../stores';

export const isDemoUser = () => SystemData?.genericData?.inDemoMode && stores.identity.isDemoUser();
export const demoMessage = demoMessageFn;
